module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento1.7e77e86e.svg";